import { Link, useHistory, useParams } from 'react-router-dom'
import ContentHeader from '../Layout/ContentHeader'
import { useLoading } from '../../LoadingOverlay/LoadingOverlayContext'
import { FormProvider, useForm } from 'react-hook-form'
import InputController from '../Global/InputController'
import Box from '../Global/Box'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import { useEffect, useState } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import {
  CREATE_GROUP,
  GET_ALL_GROUPS_FOR_SELECT,
  GET_ALL_REPORT_GROUPS_BY,
  GET_ONE_GROUP,
  UPDATE_GROUP,
} from '../../graphql/Catalog/ReportGroups/reportGroups'
import { toastSweetAlert } from '../Helpers/ToastSweetAlert'
import CheckboxCustom from '../Global/Checkbox/CheckboxCustom'
import {
  CREATE_GROUPS_CATEGORIES,
  GET_ALL_GROUPS_CATEGORIES,
  GET_ONE_GROUPS_CATEGORIES,
  UPDATE_GROUPS_CATEGORIES,
} from '../../graphql/Catalog/ReportGroups/reportCategories'
import {
  CREATE_GROUPS_CATEGORIES_SUB,
  GET_ALL_FORMS,
  GET_ALL_GROUPS_CATEGORIES_SUB_LIST,
  GET_ONE_GROUP_CATEGORY_SUB,
  UPDATE_GROUPS_CATEGORIES_SUB,
} from '../../graphql/Catalog/ReportGroups/reportSubCaterories'

const refetchTable = {
  query: GET_ALL_GROUPS_CATEGORIES_SUB_LIST,
  variables: {
    offset: 0,
    limit: 10,
    searchQuery: null,
  },
}

const singular = 'SubCategoría'
//const plural = 'Categorías'

const extensions_allowed_image = ['.jpg', '.jpeg', '.png', '.svg']
const sizeMaxFile = 5 //MB

const ReportSubCategoriesNew = () => {
  //HOOKS:
  const { id: _id } = useParams()
  const history = useHistory()
  const { showLoading, hideLoading } = useLoading()

  //STATES:
  const [file, setFile] = useState(null)
  const [icon, setIcon] = useState(null)
  const [allowCreation, setAllowCreation] = useState({
    allow_create_in_app: true,
    allow_create_in_web: true,
    show_system: true,
  })
  const [selectOptions, setSelectOptions] = useState([])
  const [selectOptsForms, setSelectOptsForms] = useState([])
  const [backPage, setBackPage] = useState(false)

  //MUTATIONS:
  const [createItem] = useMutation(CREATE_GROUPS_CATEGORIES_SUB, {
    refetchQueries: [refetchTable],
  })

  const [updateItem] = useMutation(UPDATE_GROUPS_CATEGORIES_SUB, {
    refetchQueries: [refetchTable],
  })

  //QUERYS:
  const { data, loading, error } = useQuery(GET_ONE_GROUP_CATEGORY_SUB, {
    skip: !_id,
    variables: {
      getOneGroupCategorySubId: _id ? parseInt(_id) : -1,
    },
    fetchPolicy: 'no-cache',
  })

  const options = useQuery(GET_ALL_GROUPS_CATEGORIES, {
    variables: {
      offset: 0,
      limit: null,
      searchQuery: null,
    },
    fetchPolicy: 'no-cache',
  })

  const forms = useQuery(GET_ALL_FORMS, {
    variables: {
      searchQuery: null,
      limit: null,
      offset: 0,
    },
    fetchPolicy: 'no-cache',
  })

  //USE-EFFECTS:
  useEffect(() => {
    if (_id) {
      if (!loading) {
        if (error)
          return toastSweetAlert({
            mode: 'error',
            message: error.message,
          })

        reset({
          name: data.getOneGroupCategorySub.name,
          description: data.getOneGroupCategorySub.description,
          icon: data.getOneGroupCategorySub.icon,
          group_category_id: data.getOneGroupCategorySub.group_category_id,
          allow_creation: data.getOneGroupCategorySub.allow_creation,
          form_id: data.getOneGroupCategorySub.form_id ?? '',
          allow_create_in_app: data.getOneGroupCategorySub.allow_create_in_app,
          allow_create_in_web: data.getOneGroupCategorySub.allow_create_in_web,
          show_system: data.getOneGroupCategorySub.show_system,
        })

        let icon = data.getOneGroupCategorySub.icon ?? null
        setAllowCreation({
          allow_create_in_app: data.getOneGroupCategorySub.allow_create_in_app,
          allow_create_in_web: data.getOneGroupCategorySub.allow_create_in_web,
          show_system: data.getOneGroupCategorySub.show_system,
        })
        if (
          data.getOneGroupCategorySub?.GroupsCategoriesSubToFile?.url &&
          data.getOneGroupCategorySub?.GroupsCategoriesSubToFile?.url !== ''
        ) {
          icon = data.getOneGroupCategorySub?.GroupsCategoriesSubToFile?.url
        }

        setIcon(icon)
      }
    } else {
      reset({
        name: '',
        description: '',
        icon: '',
        order: 1,
        group_id: '',
        allow_create_in_app: false,
        allow_create_in_web: false,
        show_system: false,
      })
    }
  }, [_id, loading, error, data])

  useEffect(() => {
    if (options.data && !options.loading) {
      if (options.error)
        return toastSweetAlert({
          mode: 'error',
          message: options.error.message,
        })

      let list = []
      options.data.getAllGroupsCategories?.rows.map((item) => {
        return list.push({
          value: item.id,
          label: item.name,
        })
      })
      setSelectOptions(list)
    }
  }, [options.data, options.loading, options.error])

  useEffect(() => {
    if (forms.data && !forms.loading) {
      if (forms.error)
        return toastSweetAlert({
          mode: 'error',
          message: forms.error.message,
        })

      let list = []
      forms.data.getAllForms?.rows.map((item) => {
        return list.push({
          value: item.id,
          label: item.name,
        })
      })
      setSelectOptsForms(list)
    }
  }, [forms])

  //FORM:
  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Campo requerido'),
    description: Yup.string().required('Campo requerido'),
    group_category_id: Yup.number().required('Campo requerido'),
    form_id: Yup.number().nullable(),
  })

  const {
    methods,
    handleSubmit,
    formState: { errors },
    control,
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
  })

  //FUNCTIONS:
  const handleFile = async (e) => {
    if (!e.target.files[0]) return

    const fileName = e.target.files[0].name.toLowerCase()
    const lastDot = fileName.lastIndexOf('.')
    const extension = fileName.slice(lastDot, fileName.length)

    if (extensions_allowed_image.indexOf(extension) === -1) {
      setFile(null)
      return toastSweetAlert({
        mode: 'error',
        message: `Solo se admite ${extensions_allowed_image.join(', ')}`,
      })
    }

    if (e.target.files[0].size / 1048576 > sizeMaxFile) {
      setFile(null)
      return toastSweetAlert({
        mode: 'error',
        message: `El archivo no puede superar los ${sizeMaxFile}MB`,
      })
    }

    setFile(e.target.files[0])
  }

  const onSubmit = async (data) => {
    showLoading()
    try {
      if (_id) {
        await updateItem({
          variables: {
            input: {
              name: data.name,
              description: data.description,
              file: file,
              icon: data.icon,
              group_category_id: parseInt(data?.group_category_id),
              form_id: data.form_id ? parseInt(data.form_id) : null,
              allow_create_in_app: allowCreation.allow_create_in_app,
              allow_create_in_web: allowCreation.allow_create_in_web,
              show_system: allowCreation.show_system,
            },
            updateGroupsCategoriesSubId: parseInt(_id),
          },
        })
      } else {
        await createItem({
          variables: {
            input: {
              name: data.name,
              description: data.description,
              icon: data.icon,
              file: file,
              group_category_id: parseInt(data?.group_category_id),
              form_id: data.form_id ? parseInt(data.form_id) : null,
              allow_create_in_app: allowCreation.allow_create_in_app,
              allow_create_in_web: allowCreation.allow_create_in_web,
              show_system: allowCreation.show_system,
            },
          },
        })
      }

      history.push(backPage)

      toastSweetAlert({
        mode: 'ok',
        message: `${singular} ${
          _id ? ' editado correctamente' : ' creado correctamente'
        }`,
      })
    } catch (error) {
      console.error(error)
      toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  return (
    <>
      <ContentHeader
        title=""
        breadcrumb=""
        // titleContent={
        //   <div className="col-12 col-sm-6">
        //     <Link className="btn btn-migrates-white" to={backPage}>
        //       <i className="fas fa-long-arrow-alt-left" /> Atrás
        //     </Link>
        //   </div>
        // }
        // breadcrumbContent={
        //   <div className="col-12 col-sm-12">
        //     <ol className="breadcrumb float-sm-right">
        //       <li className="breadcrumb-item">
        //         <Link to={backPage}>Categorías / </Link>
        //       </li>
        //       <li className="breadcrumb-iteem active">
        //         {` `}
        //         {_id ? 'Editar' : 'Agregar'}
        //       </li>
        //     </ol>
        //   </div>
        // }
        windowTitle={`${_id ? 'Editar' : 'Agregar'} ${singular}`}
      />

      <FormProvider {...methods}>
        <form className="px-3" onSubmit={handleSubmit(onSubmit)}>
          <Box
            title={`${_id ? 'Editar' : 'Agregar'} ${singular}`}
            btnRedPath={backPage}
            btnRedTxt="Cancelar"
            errors={errors}
            btnSubmit={true}
            BackPageHeader
            setBackPage={setBackPage}
            content={
              <>
                <div className="mb-3">
                  <div className="row">
                    <div className="mb-3 col-12 col-sm-4">
                      <InputController
                        label="Nombre *"
                        name="name"
                        control={control}
                        inputType="text"
                        placeholderTxt="Nombre del Grupo"
                        required
                      />
                      <InputController
                        label="Icono"
                        name="icon"
                        control={control}
                        inputType="hidden"
                        placeholderTxt="Icono del Grupo"
                        valueManual=""
                      />
                    </div>
                    <div className="mb-3 col-12 col-sm-4">
                      <InputController
                        label="Categoría *"
                        name="group_category_id"
                        control={control}
                        isClearable={true}
                        isSearchable={true}
                        inputType="choosen"
                        placeholderTxt="Categoría a la que pertenece"
                        options={selectOptions}
                        addClass="z-index-99"
                        required
                      />
                    </div>
                    <div className="mb-3 col-12 col-sm-4 d-flex flex-row">
                      {icon && (
                        <img src={icon} alt="icon" width="30px" height="30px" />
                      )}

                      <div className="w-100 pl-2">
                        <InputController
                          label={`Icono (${extensions_allowed_image.join(
                            ', '
                          )}) Max: ${sizeMaxFile} MB`}
                          inputType="file"
                          formatAccept="image/*"
                          alidateFormatMsg={`Solo se admite ${extensions_allowed_image.join(
                            ', '
                          )}`}
                          name="file"
                          control={control}
                          validateFormat="imageavatar"
                          changeAction={(e) => handleFile(e)}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-sm-6 mb-3 z-index-9999">
                      <InputController
                        label="Formulario Asociado"
                        name="form_id"
                        options={selectOptsForms}
                        isClearable={true}
                        isSearchable={true}
                        classNameWrap="z-index-99"
                        control={control}
                        inputType="choosen"
                        placeholderTxt="Selecciona un Formulario"
                      />
                    </div>
                    <div className="mb-3 col-12">
                      <InputController
                        label="Descripción *"
                        name="description"
                        inputType="textarea"
                        rows={3}
                        placeholderTxt="Breve descripción del Grupo"
                        control={control}
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <h3>Permisos</h3>
                  <div className="col-12 col-sm-4 mb-3">
                    <CheckboxCustom
                      label="Permitir creación de Reportes en la App"
                      name="allow_create_in_app"
                      control={control}
                      value={true}
                      labelInput="allow_create_in_app"
                      classNameWrap="pt-4"
                      onChange={(e) => {
                        setAllowCreation((prev) => ({
                          ...prev,
                          allow_create_in_app: e.target.checked,
                        }))
                      }}
                    />
                  </div>
                  <div className="col-12 col-sm-4 mb-3">
                    <CheckboxCustom
                      label="Permitir creación de Reportes en la Web"
                      name="allow_create_in_web"
                      control={control}
                      value={true}
                      labelInput="allow_create_in_web"
                      classNameWrap="pt-4"
                      onChange={(e) => {
                        setAllowCreation((prev) => ({
                          ...prev,
                          allow_create_in_web: e.target.checked,
                        }))
                      }}
                    />
                  </div>
                  <div className="col-12 col-sm-4 mb-3">
                    <CheckboxCustom
                      label="Mostrar en sistema"
                      name="show_system"
                      control={control}
                      value={true}
                      labelInput="show_system"
                      classNameWrap="pt-4"
                      onChange={(e) => {
                        setAllowCreation((prev) => ({
                          ...prev,
                          show_system: e.target.checked,
                        }))
                      }}
                    />
                  </div>
                </div>
              </>
            }
          />
        </form>
      </FormProvider>
    </>
  )
}
export default ReportSubCategoriesNew
